// action type constants
export const CREATE_NOTIFICATION_MESSAGE = 'CREATE_NOTIFICATION_MESSAGE';
export const DELETE_NOTIFICATION_MESSAGE = 'DELETE_NOTIFICATION_MESSAGE';
